<div [formGroup]="group" class="main {{ userClass }}" *ngIf="group?.controls[name]">
  <div
    class="label"
    [class.haserror-gotop]="isshow && group?.controls && name && name !== '' && group?.controls[name]?.touched && group?.controls[name]?.invalid"
    [class.gotop]="isshow"
    (focus)="focusFunction()"
    (click)="select.open()"
    (focusout)="focusOutFunction()">
    <label class="txt" [class.lbl]="isshow" [class.error]="name && name !== '' && group?.controls[name]?.touched && group?.controls[name]?.invalid">
      {{ label }}
    </label>
    <span
      class="star"
      [class.error]="name && name !== '' && group?.controls[name]?.touched && group?.controls[name]?.invalid"
      *ngIf="required === true">
      *
    </span>
  </div>
  <ng-select
    [items]="_filterdItems"
    inputmode="none"
    sepidzAutoFocus
    [formControl]="group?.controls[name]"
    bindLabel="{{ textFieldName }}"
    id="{{ name }}"
    labelForId="{{ name }}"
    bindValue="{{ valueFieldName }}"
    [loading]="loading"
    [multiple]="multiple"
    [limitSelection]="limitSelection"
    [repeatable]="repeatable"
    [clearable]="clearable"
    [clearOnBackspace]="clearOnBackspace"
    [hasSelectAll]="hasSelectAll"
    [searchable]="searchable"
    [isMultiColumns]="isMultiColumns"
    [selectOnTab]="selectOnTab"
    appendTo="body"
    (change)="onChange($event)"
    (clear)="onClear($event)"
    (add)="add($event)"
    (remove)="remove($event)"
    [closeOnSelect]="closeOnSelect"
    appearance="none"
    [disabled]="readonly || disabled"
    [loadingText]="'Message.Loading' | translate"
    [dropdownPosition]="dropdownPosition"
    class="custom"
    (search)="search($event)"
    (close)="close()"
    (open)="open()"
    [class.hasborder]="isshow"
    [class.border]="isshow"
    [class.error]="name && name !== '' && group?.controls[name]?.touched && group?.controls[name]?.invalid && !isfocus"
    (focus)="focusFunction()"
    (focusout)="focusOutFunction()"
    [tabIndex]="tabOrder"
    #select>
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <input *ngIf="multiple && hasCheckBox" [checked]="item.selected" type="checkbox" /> {{ item[textFieldName] }}
      <ng-container *ngIf="isMultiColumns && multiDataKey?.length > 0">
        <div class="d-flex">
          <div *ngFor="let display of multiDataKey; let index = index" class="option-box">
            {{ multiDataKeyTitle[index] }} : {{ item[multiDataKey[index]] }}
          </div>
        </div>
      </ng-container>
    </ng-template>
    <ng-container class="selectorfooter" *ngIf="isMultiColumns">
      <div class="pagination">
        <i class="icon icon-skip_previous-o" (click)="pagination(paginationEnum.first)"></i>
        <i class="icon icon-keyboard_arrow_left-o" (click)="pagination(paginationEnum.previous)"></i>
        <form [formGroup]="formGroup">
          <input class="pagenumber" formControlName="PaginationNumber" id="PaginationNumber" type="text" (input)="setValuePagination($event)" />
        </form>
        <span class="totalPage"> {{ totalPage }} /</span>
        <i class="icon icon-keyboard_arrow_right-o" (click)="pagination(paginationEnum.next)"></i>
        <i class="icon icon-skip_next-o" (click)="pagination(paginationEnum.last)"></i>
      </div>
    </ng-container>
  </ng-select>
  <div
    *ngIf="name && name !== '' && group?.controls && group?.controls[name] && group?.controls[name]?.touched && group?.controls[name]?.invalid"
    class="error errorsize unvisible"
    tooltip=" {{ label }} {{ 'Errors.Required' | translate }}"
    [class.visible]="
      name && name !== '' && group?.controls && group?.controls[name] && group?.controls[name]?.touched && group?.controls[name]?.invalid
    ">
    <span [hidden]="!group?.controls[name]?.errors?.required"> {{ label }} {{ "Errors.Required" | translate }} </span>
  </div>
</div>
